import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBell, FiSearch, FiActivity } = FiIcons;

const Topbar = () => {
  return (
    <header className="h-16 hud-panel border-x-0 border-t-0 fixed top-0 right-0 left-64 flex items-center justify-between px-8 z-20">
      <div className="flex items-center gap-4 w-96">
        <div className="relative w-full">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600" />
          <input 
            type="text" 
            placeholder="SEARCH TELEMETRY LOGS..." 
            className="w-full bg-[#050508] border border-[#1a1a2e] focus:border-[#00f0ff]/40 rounded-lg px-10 py-2 text-xs font-mono text-gray-400 focus:outline-none transition-all placeholder:text-gray-700"
          />
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 text-[#ff5500] px-3 py-1 bg-[#ff5500]/5 border border-[#ff5500]/20 rounded-full">
          <SafeIcon icon={FiActivity} className="animate-pulse text-xs" />
          <span className="text-[9px] font-mono uppercase tracking-widest font-bold">3 Active Hazards</span>
        </div>
        
        <div className="h-6 w-px bg-[#1a1a2e]"></div>

        <button className="relative text-gray-500 hover:text-[#00f0ff] transition-all">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#ff5500] rounded-full border-2 border-[#0a0a12]"></span>
        </button>

        <div className="flex items-center gap-3 pl-4 border-l border-[#1a1a2e]">
          <div className="text-right">
            <p className="text-xs font-bold text-gray-200 tracking-tight">OPR-77</p>
            <p className="text-[8px] font-mono text-[#00f0ff] uppercase opacity-60">Master Command</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#1a1a2e] to-[#0a0a12] border border-[#00f0ff]/30 flex items-center justify-center text-[#00f0ff] font-mono text-xs font-bold shadow-[0_0_10px_rgba(0,240,255,0.1)]">
            77
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;